import type { PageContext } from 'vike/types';
import type { Language } from '@/types/locales';

export const getLinkHref = (pageContext: PageContext, href?: string, locale?: Language) => {
    if ((locale || pageContext.locale || pageContext.defaultLocale) !== pageContext.defaultLocale) {
        return `/${locale || pageContext.locale}${locale && href === '/' ? '' : href}`;
    }

    return href;
};
